var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padding"},[_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.info.title))]),_c('div',{staticClass:"margin-t",domProps:{"innerHTML":_vm._s(_vm.info.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }